import playlist from './playlist'
import totens from './totens'
import ads from './ads'
import schedule from './schedule'
import templates from './templates'
import previews from './previews'
import letreiros from './letreiros'
export default {playlist, totens, ads, schedule, templates, previews, letreiros}